import { render, staticRenderFns } from "./NewsDate.vue?vue&type=template&id=01a90d4e&scoped=true&"
import script from "./NewsDate.vue?vue&type=script&lang=js&"
export * from "./NewsDate.vue?vue&type=script&lang=js&"
import style0 from "./NewsDate.vue?vue&type=style&index=0&id=01a90d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a90d4e",
  null
  
)

export default component.exports